module.exports = __webpack_public_path__ + "static/media/ub.85623117.png";